'use strict';

var $ = require('jquery'),
  _ = require('underscore'),
  mediator = require('mediatorjs'),
  Backbone = require('backbone'),
  config = require('../config'),
  PointyModalView = require('../components/PointyModalView');
require('../third-party/jquery.tableofcontents');

var ComponentsPage = Backbone.View.extend({

  initialize: function() {
    this.addTableOfContents();
    this.listenForModalsAndTooltips();
    this.$select = this.$('select');
    this.$select.on('change', _.bind(this.addColourClass, this));
  },

  addColourClass: function() {
    this.$el.removeClass().addClass(this.$select.val());
  },

  addTableOfContents: function() {
    this.$toc = $('#ComponentsTableOfContents');
    this.$toc.find('> ul').tableOfContents(this.$el, {
      startLevel: 2,
      depth: 1
    });
  },

  listenForModalsAndTooltips: function() {
    this.$el.on('click', '#ComponentsFullScreenModal', function() {
      mediator.trigger(config.events.cart.quantityRestriction, {});
    });
    this.$el.on('click', '#ComponentsPointyModal', function() {
      var pointy = new PointyModalView({
        el: this,
        content: $('<div><h2>pointy modal</h2></div>')
      });
      pointy.open();
    });
  }

});

module.exports = new ComponentsPage({
  el: '#ComponentsPage'
});



// WEBPACK FOOTER //
// ./assets/js/frontend-only/componentsPage.js